export const DateFormats = {
  YYYY_MM_DD: 'YYYY-MM-DD',
};
